import {Component, EventEmitter, Injectable, Input, OnChanges, Output, SimpleChanges} from '@angular/core';
import { Badge } from 'shared/models/badges/badge';

@Component({
  selector: 'badge',
  templateUrl: './badge.component.html',
  styleUrls: ['./badge.component.css'],
})

@Injectable()
export class BadgeComponent {
  @Input() badge: Badge;

  private getBadgeImage(badge: Badge): string {
    return 'assets/badge/badge'+badge.shape+'.png';
  }

}



// WEBPACK FOOTER //
// /usr/src/app/src/app/shared/badges/components/badge-component/badge.component.ts